import styled from "styled-components"
import Overlay from "../../../Componentes/Overlay"
import Formulario from "../../../Componentes/Utils/Formulario"
import Modal from "../../../Componentes/Utils/Modal"
import { useModal } from "../../../contexts/ModalContext"
import { useEffect, useState } from "react"
import useApi from "../../../hooks/useApi";

const Titulo = styled.h2`
    margin: 5px auto;
    color: #000;
    text-align: center;
`
const ContainerForm = styled.div`
    width: 100%;
    border-radius: 12px;
    margin-top: 15px;
    overflow: hidden;
    border: 1px solid rgba( 0,0,0, 0.2 );
    box-sizing: border-box;
`
const TabelaForm = styled.table`
    width: 100%;
    border-collapse: collapse;
`
const CabecalhoTable = styled.thead`
    background-color:rgba(219, 219, 219, 0.6);
    height: 35px;
    color: #000;
    tr{
        box-shadow: 0 4px 6px rgba(0, 0, 0, 0.2);
    }
`
const SideColuna = styled.td`
    background-color:rgba(219, 219, 219, 0.6);
    font-weight: bold;
    padding-left: 15px;
    color: #000;
`
const LinhaCorpo = styled.tr`
    height: 40px;
    box-sizing: border-box;
    td{
        width: 33.33%;
    }
    &:not(:last-child){
        border-bottom: 1px solid rgba( 0,0,0, 0.2 );
    }
`
const InputTable = styled.input`
    width: 100%;
    height: 32px;
    margin: 0;
    border: 1px solid #aaa;
    border-radius: 4px;
    font-size: 14px;
    box-sizing: border-box;
    padding-left: 5px;
    outline: none;
    &:focus {
        border: 1px solid rgba(0, 68, 255, 0.6);
    }
`;
const BotaoSalvar = styled.button`
    width: 150px;
    height: 30px;
    border-radius: 5px;
    background-color: rgb(42, 209, 0);
    border: none;
    margin: 10px 0 0 auto;
    font-weight: bold;
    color: white;
    cursor: pointer;
    transition: .3s;
    &:hover{
        scale: 1.05;
    }
`

const tipos = ['INICIAL', 'PERIÓDICO', 'EVENTUAL', 'COMPLEMENTAR'];
const campos = ['validade', 'carga']

const ModalEditConfig = ({ item, onSuccess }) => {
    const api = useApi();


    const { closeModal } = useModal();
    const [ loading, setLoading ] = useState( true );
    const [ saving, setSaving ] = useState( false );

    const [ formValues, setFormValues ] = useState({
        INICIAL: { validade: '', carga: '' },
        PERIÓDICO: { validade: '', carga: '' },
        EVENTUAL: { validade: '', carga: '' },
        COMPLEMENTAR: { validade: '', carga: '' }
    })

    const fetchValues = async () => {

        setLoading( true );
        if( !item.identifier ){

            setLoading( false );
            return;

        }

        try{

            const { data } = await api.post('/Painel/API/Treinamentos/GetTreinamentoConfig/',
                { identifier: item.identifier },
                { withCredentials: true }
            )

            setFormValues( data );
            console.log( data )

        }catch( error ){

            console.log( error );

        }finally{

            setLoading( false );

        }

    }

    useEffect(() => {

        fetchValues();

    }, [ item.identifier ])

    const handleChange = ( tipo, campo, valor ) => {
        setFormValues( prev => ({
            ...prev,
            [tipo]: {
                ...prev[tipo],
                [campo]: valor
            }
        }))
    }

    const handleSubmit = async ( e ) => {

        e.preventDefault();
        setSaving( true )

        try{

            const payload = {
                identifier: item.identifier,
                dados: formValues
            }

            await api.post('/Painel/API/Treinamentos/SaveTreinamentoConfig/', payload, {
                withCredentials: true
            })

            await onSuccess();
            closeModal()

        }catch( e ){

            console.log( e )

        }finally{

            setSaving( false );

        }

    }

    return (
        <Overlay state={true} >
            <Modal size="lg" header={true} close={closeModal} >
                <Titulo>
                    {item.treinamento}
                </Titulo>
                <Formulario>
                    <ContainerForm>
                        <TabelaForm>
                            <CabecalhoTable>
                                <tr>
                                    <th>TIPO TREINAMENTO</th>
                                    <th>VÁLIDADE</th>
                                    <th>CARGA HORÁRIA</th>
                                </tr>
                            </CabecalhoTable>
                            <tbody>
                                {tipos.map(tipo => (
                                    <LinhaCorpo key={tipo} >
                                        <SideColuna>{tipo}</SideColuna>
                                        {campos.map(campo => (
                                            <td key={campo} >
                                                <InputTable
                                                    type="number"
                                                    min="0"
                                                    value={ formValues[tipo][campo] }
                                                    onChange={ e => handleChange( tipo, campo, e.target.value )}
                                                    disabled={ saving }
                                                />
                                            </td>
                                        ))}
                                    </LinhaCorpo>
                                ))}
                            </tbody>
                        </TabelaForm>
                    </ContainerForm>
                    <BotaoSalvar disabled={ saving } onClick={ ( e ) => handleSubmit( e ) } >
                        { saving ? 'SALVANDO...' : 'SALVAR' }
                    </BotaoSalvar>
                </Formulario>
            </Modal>
        </Overlay>
    )

}

export default ModalEditConfig;